var map = {
	"./photo1.webp": 5665,
	"./photo10.webp": 7503,
	"./photo11.webp": 5916,
	"./photo12.webp": 7529,
	"./photo13.webp": 7806,
	"./photo14.webp": 7539,
	"./photo15.webp": 3456,
	"./photo16.webp": 2109,
	"./photo17.webp": 2194,
	"./photo18.webp": 2343,
	"./photo19.webp": 7636,
	"./photo2.webp": 6404,
	"./photo20.webp": 1732,
	"./photo21.webp": 2743,
	"./photo22.webp": 2070,
	"./photo23.webp": 8449,
	"./photo24.webp": 5544,
	"./photo25.webp": 3915,
	"./photo3.webp": 9415,
	"./photo4.webp": 6698,
	"./photo5.webp": 8197,
	"./photo6.webp": 7096,
	"./photo7.webp": 3547,
	"./photo8.webp": 1854,
	"./photo9.webp": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8138;